export * from './filterModels';

export default class FiltersHandler {
    constructor(filterColumns) {
        this.columns = filterColumns;
    }

    /**
     *
     * @param {TableModel} table
     */
    attach(table) {
        this.table = table;
    }

    restore() {
        const filters = this.table.getFilters();
        Object.entries(filters).forEach(([field, value]) => {
            const { filter } = this.columns[field] || {};
            if (!filter) {
                return;
            }
            filter.load(value, filters);
        });
    }
}
